import { SectionReveal } from "@/components/common/SectionReveal";
import { BookOpen, ArrowRight, Clock } from "lucide-react";

const POSTS = [
  {
    title:
      "The Halal GO Standard: What 'Serving Halal with Integrity' Means to Us.",
    category: "Our Story",
    excerpt:
      "Integrity isn't just a tagline — it's how we vet every kitchen, handle every order, and earn your trust, one meal at a time.",
    img: "/showcase/hero-spread.png",
    read: "5 min read",
  },
  {
    title: "Top 5 Hidden Gem Halal Restaurants in the Philippines.",
    category: "Food Guide",
    excerpt:
      "From Manila to Zamboanga, we're rounding up the neighbourhood kitchens serving unforgettable halal food you need to try.",
    img: "/showcase/manila-halal-hub.png",
    read: "6 min read",
  },
  {
    title:
      "Behind the Scenes: Designing Eco-Friendly Packaging for Halal GO.",
    category: "Behind the Scenes",
    excerpt:
      "Why we chose kraft over plastic, and how thoughtful packaging keeps your food safe, fresh, and kinder to the planet.",
    img: "/brand/food-packaging.png",
    read: "4 min read",
  },
];

export default function Blog() {
  return (
    <div data-testid="blog-page">
      {/* Header */}
      <section className="hero-wash">
        <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:px-8">
          <span className="inline-flex items-center gap-2 rounded-full border border-halalgo-green-200 bg-halalgo-green-50 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-halalgo-green-800">
            <BookOpen className="h-3.5 w-3.5" /> Community Hub
          </span>
          <h1 className="mt-5 text-4xl font-bold tracking-tight text-halalgo-ink sm:text-5xl">
            Halal GO Community Hub
          </h1>
          <p className="mt-4 max-w-xl text-halalgo-ink/70">
            Stories, guides and behind-the-scenes from the Halal GO family — rooted
            in trust, community and great halal food across the Philippines.
          </p>
        </div>
      </section>

      {/* Post grid */}
      <section className="mx-auto max-w-6xl px-4 pb-12 sm:px-6 lg:px-8">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {POSTS.map((post, i) => (
            <SectionReveal
              key={post.title}
              as="article"
              delay={i * 0.08}
              data-testid="blog-post-card"
              className="group flex flex-col overflow-hidden rounded-xl border border-halalgo-kraft-100 bg-white shadow-lift-sm transition-shadow hover:shadow-lift-md"
            >
              <div className="relative overflow-hidden">
                <img
                  src={post.img}
                  alt={post.title}
                  className="h-48 w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <span className="absolute left-3 top-3 rounded-md bg-white/90 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-halalgo-green-800 backdrop-blur">
                  {post.category}
                </span>
                <span className="absolute right-3 top-3 rounded-md bg-halalgo-kraft-500 px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide text-halalgo-ink">
                  Coming soon
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5">
                <h2 className="text-lg font-semibold leading-snug text-halalgo-ink">
                  {post.title}
                </h2>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-halalgo-ink/70">
                  {post.excerpt}
                </p>

                <div className="mt-5 flex items-center justify-between border-t border-halalgo-kraft-100 pt-4">
                  <div className="flex items-center gap-2">
                    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-halalgo-green-600 text-[11px] font-bold text-white">
                      HG
                    </span>
                    <span className="text-xs font-medium text-halalgo-ink/70">
                      Halal GO Team
                    </span>
                  </div>
                  <span className="inline-flex items-center gap-1 text-xs text-halalgo-ink/55">
                    <Clock className="h-3.5 w-3.5" /> {post.read}
                  </span>
                </div>

                <span
                  aria-disabled="true"
                  className="mt-4 inline-flex cursor-default items-center gap-1 text-sm font-semibold text-halalgo-green-700"
                >
                  Read more <ArrowRight className="h-4 w-4" />
                </span>
              </div>
            </SectionReveal>
          ))}
        </div>

        <p className="mt-10 text-center text-sm text-halalgo-ink/55">
          More stories are on the way. Watch this space — the Halal GO journal is
          just getting started.
        </p>
      </section>
    </div>
  );
}
